import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';
import { Database } from '@/_constants/database.types';

type Question = Database['public']['Tables']['questions']['Row'];

export interface QuestionWithOrder extends Question {
  question_order: number;
}

const usePaperQuestions = (paperId: string | undefined) => {
  const queryFn = async (): Promise<QuestionWithOrder[]> => {
    if (!paperId) return [];

    // Fetch questions directly from questions table (one-to-many relationship)
    const { data, error } = await supabaseClient
      .from('questions')
      .select('*')
      .eq('past_paper_id', paperId)
      .order('question_order');

    if (error) throw error;

    return (data as QuestionWithOrder[]) || [];
  };

  return useQuery({
    queryKey: ['paper_questions', paperId],
    queryFn,
    enabled: !!paperId,
  });
};

export default usePaperQuestions;
